import { useDispatch, useSelector } from "react-redux";
import getOr from "lodash/fp/getOr";
import mapValues from "lodash/mapValues";
import pick from "lodash/fp/pick";

import { setCustomisationId, setSelectedImageAngle } from "store/app/appSlice";
import {
  selectCustomisations,
  selectFieldsForQueryParams,
  selectSelectedCustomisationId,
  selectUserChoiceValues,
  selectSelectedProduct,
  selectUIVersion,
} from "store/app";
import {} from "components";
import { useSetQueryString } from "hooks";
import ProductV1 from "./ProductV1";
import ProductV2 from "./ProductV2";

export default function Product({
  restrictedModeEnabled,
  changeProduct,
  appHeaderLogo,
  appDivider,
  publicDirectoryUrl,
}) {
  const dispatch = useDispatch();
  const product = useSelector(selectSelectedProduct);
  const UIVersion = useSelector(selectUIVersion);

  const isAddingProductToOrder = useSelector(
    getOr(false, ["app", "isAddingProductToOrder"])
  );

  const customisations = useSelector(selectCustomisations);
  const selectedCustomisationId = useSelector(selectSelectedCustomisationId);
  const userChoiceValues = useSelector(selectUserChoiceValues);
  const fieldsForQueryParams = useSelector(selectFieldsForQueryParams);
  const selectedImageViewAngle = useSelector(
    ({ app }) => app.selectedImageAngle
  );

  // only set query params for customisation tabs the user has visited
  useSetQueryString(pick(fieldsForQueryParams)(userChoiceValues));

  const dispatchSetCustomisationId = (id) => dispatch(setCustomisationId(id));

  const dispatchSetSelectedImageAngle = (imageViewAngle) =>
    dispatch(setSelectedImageAngle(imageViewAngle));

  if (!product) {
    return null;
  }

  const imageViewAnglesObj = mapValues(
    product?.images || {},
    ({ icon }) => icon
  );

  const showChangeImageAngleArrowButtons =
    product?.showChangeImageAngleArrowButtons &&
    Object.keys(imageViewAnglesObj).length > 1;

  if (UIVersion === 2) {
    return (
      <ProductV2
        restrictedModeEnabled={restrictedModeEnabled}
        appHeaderLogo={appHeaderLogo}
        appDivider={appDivider}
        changeProduct={changeProduct}
        customisations={customisations}
        selectedCustomisationId={selectedCustomisationId}
        userChoiceValues={userChoiceValues}
        selectedImageViewAngle={selectedImageViewAngle}
        imageViewAnglesObj={imageViewAnglesObj}
        showChangeImageAngleArrowButtons={showChangeImageAngleArrowButtons}
        dispatchSetCustomisationId={dispatchSetCustomisationId}
        dispatchSetSelectedImageAngle={dispatchSetSelectedImageAngle}
        dispatch={dispatch}
        publicDirectoryUrl={publicDirectoryUrl}
      />
    );
  }

  return (
    <ProductV1
      isAddingProductToOrder={isAddingProductToOrder}
      changeProduct={changeProduct}
      customisations={customisations}
      selectedCustomisationId={selectedCustomisationId}
      userChoiceValues={userChoiceValues}
      imageViewAnglesObj={imageViewAnglesObj}
      selectedImageViewAngle={selectedImageViewAngle}
      showChangeImageAngleArrowButtons={showChangeImageAngleArrowButtons}
      dispatchSetCustomisationId={dispatchSetCustomisationId}
      dispatchSetSelectedImageAngle={dispatchSetSelectedImageAngle}
      dispatch={dispatch}
    />
  );
}
